import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { QuoteBiddingDetails } from '@views/screens/Quote';
import type { AxiosResponse } from 'axios';

export const getQuoteBiddingDetailsAPI = (quoteKey: string) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/carriers/bidding-details`,
    method: 'get',
    params: { quoteKey },
  });
};

export type QuoteBiddingDetailsResponse = QuoteBiddingDetails[];

export const fetchQuoteBiddingDetails = async (quoteKey: string): Promise<QuoteBiddingDetailsResponse> => {
  const response: AxiosResponse<QuoteBiddingDetailsResponse> = await getQuoteBiddingDetailsAPI(quoteKey);
  return response.data;
};
